<template>
	<span :class="bemm()" @click.stop>
		<Button
			v-for="(item, index) in props.actions"
			:key="`${item.icon}-${item.label || index}`"
			:class="bemm('button')"
			:icon="item.icon"
			:tooltip="item.tooltip || item.label || ''"
			:aria-label="item.label || item.tooltip || String(item.icon)"
			:disabled="item.disabled"
			:variant="item.variant || 'ghost'"
			:size="item.size || 'small'"
			:color="item.color || 'theme'"
			@click="item.action?.()"
		/>
	</span>
</template>

<script lang="ts" setup>
import { useBemm } from 'bemm';
import { Button } from '../Button';
import type { ActionItem } from './Actions.model';

const props = withDefaults(
	defineProps<{
		actions?: ActionItem[];
	}>(),
	{
		actions: () => [],
	}
);

const bemm = useBemm('ar-actions', {
	return: 'string',
	includeBaseClass: true,
});
</script>

<style lang="scss">
.ar-actions {
	display: inline-flex;
	align-items: center;
	gap: calc(var(--space-xs) * 0.5);

	&__button {
		flex-shrink: 0;
	}
}
</style>
